import React, { useState } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from '@material-ui/core';
import { Formik, Field, Form, FieldArray } from 'formik';
import style from '../formik.module.css';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getAllSchoolAsync,
  updateSchoolDigitalDeliverableAsync,
  uploadFileAsync,
} from '../bccTeenybeansStore/bccTeenybeansStoreSlice';
import CloseIcon from '@material-ui/icons/Close';

const styles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};

const initialValues = {
  digitalDeliverable: [
    {
      docS3Key: '',
      title: '',
      description: '',
    },
  ],
};

function DigitalDelivarable({ userMailId, schoolId }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);

  const handleUploadDocument = (e, index, setFieldValue) => {
    const maxSize = 1024 * 1024 * 2;
    if (e.target.files[0].size > maxSize) {
      toast.error('File size exceeds the limit of 2MB');
    } else {
      dispatch(uploadFileAsync({ file: e.target.files[0] }))
        .unwrap()
        .then((res) => {
          setFieldValue(
            `digitalDeliverable.${index}.docS3Key`,
            res && res.data && res.data.document
          );
        });
    }
  };

  console.log('schoolId', schoolId);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={() => setOpenModal(true)}>
        Upload New Document
      </Button>
      <Modal
        className={styles.premiumModal}
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Box sx={styles}>
          <Box display="flex" justifyContent={'space-between'}>
            <Typography variant="h6" component="h2" mb={2}>
              Upload Deliverable
            </Typography>
            <Box sx={{ cursor: 'pointer' }}>
              <CloseIcon
                fontSize="medium"
                onClick={() => setOpenModal(false)}
              />
            </Box>
          </Box>
          <Box>
            <Formik
              initialValues={initialValues}
              onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));
                const payload = {
                  ...values.digitalDeliverable[0],
                };
                dispatch(
                  updateSchoolDigitalDeliverableAsync({
                    id: schoolId && schoolId,
                    data: payload,
                  })
                )
                  .unwrap()
                  .then((res) => {
                    setOpenModal(false);
                    // send mail api
                    sendWelcomeMail(userMailId);
                    function sendWelcomeMail(userMailId) {
                      // ---------Mail sent-----------------
                      let formData = new FormData();
                      formData.append('sendMail', 'true');
                      formData.append('reciever', userMailId);
                      formData.append('sender', 'Teeny Beans');
                      formData.append('senderMail', 'no-reply@teenybeans.in');
                      formData.append(
                        'subject',
                        'Your File has been uploaded for Review Purposes'
                      );
                      formData.append(
                        'message',
                        `<html>
      <body style="background-color:#f5f8f5;padding:16px;">
      <div style="text-align:center">
        <a href="#"><img style="width:150px;" src="https://teenybeans.in/assets/tb-logo1.png"></a>
      </div>
      <div style="padding-top:16px;">Dear Partner,</div>
      <div style="padding-top:16px;">We are one step closer! Just a quick note to let you know that file has been successfully uploaded for review. The document is now ready for assessment and evaluation.</div>
      <div style="padding-top:16px;">Use the following link to login into partner portal account:</div>
      <div style="padding-top:16px;">URL: <a href="https://portal.teenybeans.in/">https://portal.teenybeans.in/</a><div>
      <div style="padding-top:16px;">Please examine the content we have provided. If any additional information or clarification is required, please reach out to us we will promptly reach out to you.</div>
      <div style="padding-top:16px;">We appreciate your cooperation and look forward to processing the review efficiently.</div>
      <div style="padding-top:16px;">Best regards,</div>
      </body>
      <html>
      `
                      );
                      fetch('https://mailapi.teenybeans.in/009/', {
                        method: 'POST',
                        body: formData,
                      })
                        .then(function (response) {
                          response.json().then(function (data) {});
                        })
                        .catch(function (err) {
                          // console.log('Fetch Error :-S', err)
                        });
                    }
                    //
                    toast.success(
                      'School Digital Deliverable Updated Successfully'
                    );
                    dispatch(
                      getAllSchoolAsync({
                        params: { page: 1, limitPerPage: 10 },
                      })
                    );
                  })
                  .catch((err) => {
                    toast.error(err.message);
                  });
              }}
              validate={(values) => {
                const errors = {};
                values.digitalDeliverable.forEach((field, index) => {
                  if (
                    field.docS3Key === '' ||
                    field.title === '' ||
                    field.description === ''
                  ) {
                    errors[`digitalDeliverable${index}`] = 'Field is required';
                  }
                });
                return errors;
              }}>
              {({ values, setFieldValue }) => (
                <Form>
                  <FieldArray name="digitalDeliverable">
                    {({ insert, remove, push }) => (
                      <>
                        {values.digitalDeliverable.length > 0 &&
                          values.digitalDeliverable.map((document, index) => (
                            <div className="row" key={index}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`digitalDeliverable.${index}.title`}>
                                    Title
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`digitalDeliverable.${index}.title`}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`digitalDeliverable.${index}.description`}>
                                    Description
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`digitalDeliverable.${index}.description`}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`digitalDeliverable.${index}.uploadDocument`}>
                                    Upload document
                                  </label>
                                  <input
                                    name={`digitalDeliverable.${index}.uploadDocument`}
                                    className={style.field}
                                    type={'file'}
                                    accept=".pdf, .mp4, .mp3, image/*"
                                    onChange={(e) =>
                                      handleUploadDocument(
                                        e,
                                        index,
                                        setFieldValue
                                      )
                                    }
                                  />
                                </Grid>
                                {/* <Grid item xs={12}>
                            <Box textAlign={'right'}>
                              <Button
                                type="button"
                                variant="outlined"
                                className="secondary"
                                onClick={() => remove(index)}>
                                Remove
                              </Button>
                            </Box>
                          </Grid> */}
                              </Grid>
                            </div>
                          ))}
                        {/* <Box mt={-6}>
                    <Button
                      type="button"
                      variant="contained"
                      className="secondary"
                      onClick={() =>
                        push({
                          docS3Key: '',
                          title: '',
                          description: '',
                        })
                      }>
                      Add Documents
                    </Button>
                  </Box> */}
                      </>
                    )}
                  </FieldArray>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Button variant="contained" color="primary" type="submit">
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default DigitalDelivarable;
